import { displayDefaultDateTime } from 'app/shared/util/date-utils';
import * as _ from 'lodash';
import React from 'react';

export const columns = [
  {
    title: 'Mã',
    sorter: true,
    key: 'code',
    width: 60,
    fixed: 'left',
    defaultShow: true,
    dataIndex: 'code',
  },
  {
    title: 'Lĩnh vực/Dự án/Mảng CV',
    key: 'fieldName',
    fixed: 'left',
    defaultShow: false,
    width: 120,
    render(item) {
      const { fieldName, projectName, workTypeName } = item;

      if (!fieldName && !projectName && !workTypeName) return null;

      const segments = [fieldName, projectName, workTypeName].filter(Boolean);

      return (
        <div>
          {segments.map((segment, index) => (
            <span key={index}>
              {segment}
              {index < segments.length - 1 && '/'}
            </span>
          ))}
        </div>
      );
    }
  },
  {
    title: 'Mức độ ưu tiên',
    sorter: true,
    width: 120,
    defaultShow: true,
    key: 'workPriorityLevel',
    dataIndex: 'workPriorityLevel',
    fixed: 'left',
  },
  {
    title: 'Nội dung công việc',
    key: 'purpose',
    width: 300,
    defaultShow: true,
    fixed: 'left',
    dataIndex: 'purpose',
  },
  {
    title: 'Thời hạn hoàn thành',
    key: 'dueDate',
    width: 120,
    defaultShow: true,
    dataIndex: 'dueDate',
    render: item => item && displayDefaultDateTime(item),
  },
  {
    title: 'Tình Trạng',
    key: 'workStatusName',
    width: 80,
    defaultShow: true,
    dataIndex: 'workStatusName',
  },
  {
    title: 'Ngày hoàn thành',
    key: 'completedOn',
    width: 120,
    defaultShow: true,
    dataIndex: 'completedOn',
    render: item => item && displayDefaultDateTime(item),
  },
  {
    title: 'Đã hoàn thành',
    key: 'completeNote',
    sorter: true,
    defaultShow: true,
    width: 200,
    dataIndex: 'completeNote',
  },
  {
    title: 'Lý do (không hoàn thành,tạm dừng,hủy)',
    key: 'unfinishedNote',
    width: 200,
    defaultShow: true,
    dataIndex: 'unfinishedNote',
  },
  {
    title: 'Ngày hoàn thành dự kiến',
    key: 'expectedCompleteOn',
    width: 120,
    defaultShow: true,
    dataIndex: 'expectedCompleteOn',
    render: item => item && displayDefaultDateTime(item),
  },
  {
    title: 'Kế hoạch kỳ tiếp theo',
    key: 'nextPlanPeriodPurpose',
    width: 120,
    defaultShow: true,
    dataIndex: 'nextPlanPeriodPurpose',
  },
  {
    title: 'Khó khăn & nguyên nhân',
    key: 'issue',
    width: 200,
    defaultShow: true,
    dataIndex: 'issue',
  },
  {
    title: 'Giải pháp & kiến nghị',
    key: 'solution',
    width: 200,
    defaultShow: true,
    dataIndex: 'solution',
  },
  {
    title: 'Người giao việc',
    key: 'assignedBy',
    width: 120,
    sorter: true,
    defaultShow: true,
    dataIndex: 'assignedBy',
  },
  {
    title: 'PIC',
    key: 'picName',
    width: 120,
    sorter: true,
    defaultShow: true,
    dataIndex: 'picName',
  },
];

export const columnsCheckIn = [
  {
    title: 'Mã',
    sorter: true,
    key: 'code',
    width: 60,
    fixed: 'left',
    defaultShow: true,
    dataIndex: 'code',
  },
  {
    title: 'Lĩnh vực/Dự án/Mảng CV',
    key: 'fieldName',
    fixed: 'left',
    defaultShow: false,
    width: 120,
    render(item) {
      const { fieldName, projectName, workTypeName } = item;

      if (!fieldName && !projectName && !workTypeName) return null;

      const segments = [fieldName, projectName, workTypeName].filter(Boolean);

      return (
        <div>
          {segments.map((segment, index) => (
            <span key={index}>
              {segment}
              {index < segments.length - 1 && '/'}
            </span>
          ))}
        </div>
      );
    }
  },
  {
    title: 'Mức độ ưu tiên',
    sorter: true,
    width: 120,
    defaultShow: true,
    key: 'workPriorityLevel',
    dataIndex: 'workPriorityLevel',
    fixed: 'left',
  },
  {
    title: 'Nội dung công việc',
    key: 'purpose',
    width: 300,
    defaultShow: true,
    fixed: 'left',
    dataIndex: 'purpose',
  },
  {
    title: 'Thời hạn hoàn thành',
    key: 'dueDate',
    width: 120,
    defaultShow: true,
    dataIndex: 'dueDate',
    render: item => item && displayDefaultDateTime(item),
  },
  {
    title: 'Tình Trạng',
    key: 'workStatusName',
    width: 80,
    defaultShow: true,
    dataIndex: 'workStatusName',
  },
  {
    title: 'Ngày hoàn thành',
    key: 'completedOn',
    width: 120,
    defaultShow: true,
    dataIndex: 'completedOn',
    render: item => item && displayDefaultDateTime(item),
  },
  {
    title: 'Đã hoàn thành',
    key: 'completeNote',
    sorter: true,
    defaultShow: true,
    width: 200,
    dataIndex: 'completeNote',
  },
  {
    title: 'Lý do (không hoàn thành,tạm dừng,hủy)',
    key: 'unfinishedNote',
    width: 200,
    defaultShow: true,
    dataIndex: 'unfinishedNote',
  },
  {
    title: 'Ngày hoàn thành dự kiến',
    key: 'expectedCompleteOn',
    width: 120,
    defaultShow: true,
    dataIndex: 'expectedCompleteOn',
    render: item => item && displayDefaultDateTime(item),
  },
  {
    title: 'Kế hoạch kỳ tiếp theo',
    key: 'nextPlanPeriodPurpose',
    width: 120,
    defaultShow: true,
    dataIndex: 'nextPlanPeriodPurpose',
  },
  {
    title: 'Khó khăn & nguyên nhân',
    key: 'issue',
    width: 200,
    defaultShow: true,
    dataIndex: 'issue',
  },
  {
    title: 'Giải pháp & kiến nghị',
    key: 'solution',
    width: 200,
    defaultShow: true,
    dataIndex: 'solution',
  },
  {
    title: 'Người giao việc',
    key: 'assignedBy',
    width: 120,
    sorter: true,
    defaultShow: true,
    dataIndex: 'assignedBy',
  },
  {
    title: 'PIC',
    key: 'picName',
    width: 120,
    sorter: true,
    defaultShow: true,
    dataIndex: 'picName',
  },
];
